import { afterNextRender, ApplicationRef, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { DialogContainerComponent } from './core/dynamic-dialog/dialog-container.component';

@Component({
  selector: 'app-root',
  imports: [ RouterOutlet, DialogContainerComponent ],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  constructor() {
    const document = inject(DOCUMENT);
    const app = inject(ApplicationRef);
    afterNextRender(() => {
      void app.whenStable().then(() => document.documentElement.removeAttribute('data-language-pending'));
    });
  }
}
